import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
	fetchCategories, fetchFeatured, fetchMultipleFeatured, fetchPosts, setPage, getPageNum
} from '../actions/index';
import BlueHero from './page-top/blue-hero';
import FeaturedTop from './page-top/featured-top';
import FilterSideBar from './filters/filter-side-bar';
import SearchForm from './filters/search-form';
import PostView from './post-view';
import MagazineView from './magazine-view';
import Pagination from './filters/pagination';
import smoothScroll from 'smoothscroll';
import Loading from '../../components/loading-component';

class ArchiveSearch extends Component {
	constructor( props ) {
		super( props );
		var pageNum = this.props.getPageNum();
		this.props.setPage(pageNum);

		this.state = {
			ready: false,
			page: pageNum,
			showFilters: false,
			isMobile: false,
			prevScrollTop: 0,
		};
	}

	toggleFilters() {
		this.setState( ( prevState ) => {
			const newShowFilters = !prevState.showFilters;

			// Toggle body scroll based on the state
			if ( newShowFilters ) {
				document.body.classList.add( 'no-scroll' );
			} else {
				document.body.classList.remove( 'no-scroll' );
			}

			return { showFilters: newShowFilters };
		} );
	}

	componentDidMount() {
		this.handleResize();
		window.addEventListener( 'resize', this.handleResize.bind( this ) );

		this.handleScroll = this.handleScroll.bind( this );
		window.addEventListener( 'scroll', this.handleScroll );
		this.sidebarRef = React.createRef();
		this.handleScroll();
	}

	handleScroll() {
		const scrollTop = window.scrollY;
		const sidebar = this.sidebarRef.current;
		const footer = document.querySelector('.site-footer');
		if (!sidebar || !footer) {
			return;
		}
		const footerRect = footer.getBoundingClientRect();
		const windowHeight = window.innerHeight;
		if (footerRect.top <= windowHeight) {
		  const overlap = windowHeight - footerRect.top;
		  sidebar.style.bottom = `${overlap}px`;
		  sidebar.style.top = 'auto';
		  sidebar.style.height = '130vh';
		  sidebar.style.overflowY = 'hidden';
		} else {
		  sidebar.style.position = 'fixed';
		  sidebar.style.top = 'initial';
		  sidebar.style.bottom = 'auto';
		  sidebar.style.height = '100%';
		  sidebar.style.overflowY = 'auto';
		}
		if (this.state.showSideBar) {
		  sidebar.style.bottom = 'auto';
		  sidebar.style.top = 0;
		}
	}


	componentWillUnmount() {
		window.removeEventListener( 'resize', this.handleResize.bind( this ) );
		window.removeEventListener( 'scroll', this.handleScroll );

	}

	handleResize() {
		//IF UPDATING SIZE HERE, UPDATE IN _CATEGORY-ARCHIVE.SCSS AS WELL.
		const isMobile = window.innerWidth <= 992;

		if ( !isMobile && this.state.showFilters ) {
			this.setState( { showFilters: false } );
			document.body.classList.remove( 'no-scroll' );
		} else {
			this.setState( { isMobile } );
		}
	}

	loadData() {
		this.setState( {
			               ready: true
		               } );
	}

	setActiveCategory( params ) {
		this.activeCategory = params.categorySlug;
		if ( typeof params.subCategorySlug !== 'undefined' ) {
			this.activeCategory = params.subCategorySlug;
		}
	}

	setCategoryNiceName( params ) {
		this.activeCategoryNiceName = ISDA_Main.categories.filter( category => category.slug === params.categorySlug )[ 0 ].name;
	}

	setSubCategories( params ) {
		this.subCategories = params;
	}

	componentWillMount() {
		this.loadData();

		if ( !this.props.categories.length ) {
			this.props.fetchCategories();
		}

		this.setActiveCategory( this.props.match.params );
		this.setCategoryNiceName( this.props.match.params );



		this.setSubCategories( this.getSubCategroies() );

		const subCategories = this.getSubCategorySlugs( this.getSubCategroies() );
		const topLevelCategoryDetails = ISDA_Main.categories.find( ( category ) => category.slug === this.activeCategory );

		if (topLevelCategoryDetails.children.length > 4 && subCategories.length >= topLevelCategoryDetails.children.length - 1) {
			this.props.fetchMultipleFeatured( [this.activeCategory] );
		} else {
			this.props.fetchMultipleFeatured( subCategories.length > 0
											? subCategories
											: [this.activeCategory] );
		}

		this.props.fetchPosts( this.activeCategory, this.props.pagination.perPage, this.props.pagination.pageNum, this.props.searchTerm, this.props.dateRange.startDate, this.props.dateRange.endDate, this.getSubCategroies() );

		// Get query parameters
		this.getSubCategroies();
	}

	componentWillUpdate( nextProps ) {
		if( !window.location.href.includes(`\/search\/`) ){
			let bodyElement = document.getElementsByTagName('body');
			bodyElement[0].classList.remove('search');
			bodyElement[0].classList.remove('search-results');
		} else {
			// Do nothing
		}

		this.setActiveCategory( nextProps.match.params );
		this.setCategoryNiceName( nextProps.match.params );
		 
		if ( this.props.match.params.subCategorySlug !== nextProps.match.params.subCategorySlug || this.props.pagination.perPage !== nextProps.pagination.perPage || this.props.pagination.pageNum !== nextProps.pagination.pageNum || this.props.dateRange !== nextProps.dateRange || this.props.categories.length !== nextProps.categories.length || this.props.searchTerm !== nextProps.searchTerm ) {
			this.props.fetchPosts( this.activeCategory, nextProps.pagination.perPage, nextProps.pagination.pageNum, nextProps.searchTerm, nextProps.dateRange.startDate, nextProps.dateRange.endDate, this.getSubCategroies() );
			const subCategories = this.getSubCategorySlugs( this.getSubCategroies() );
			const topLevelCategoryDetails = ISDA_Main.categories.find( ( category ) => category.slug === this.activeCategory );
	
			if (topLevelCategoryDetails.children.length > 4 && subCategories.length >= topLevelCategoryDetails.children.length - 1) {
				this.props.fetchMultipleFeatured( [this.activeCategory] );
			} else {
				this.props.fetchMultipleFeatured( subCategories.length > 0
												? subCategories
												: [this.activeCategory] );
			}
		}

		if ( this.props.match.params.subCategorySlug !== nextProps.match.params.subCategorySlug ) {
			this.props.setPage( 1 );
		}

		let doc = document.documentElement,
		    top = (window.pageYOffset || doc.scrollTop
		          ) - (doc.clientTop || 0
		          );

		if ( this.activeCategory !== 'opinions' && top > 400 ) {
			smoothScroll( document.getElementById( 'react-scroll-point' ) );
		}
	}

	getSubCategroies() {
		// Parse the URL search parameters to get categories
		const params = new URLSearchParams( this.props.location.search );
		const subcategories = params.get( 'subcategories' );

		// You can now use `categories` for further logic
		if ( subcategories == null ) {
			return [];
		} else {
			return subcategories.split( ',' ); // Ensure it's returned as an array
		}
	}

	getSubCategorySlugs( categories = [] ) {
		if ( categories.length === 0 ) {
			return [];
		} else {
			return categories.map( ( subcategory ) => {
				return ISDA_Main.categories.find( category => category.cat_ID === parseInt( subcategory ) ).slug;
			} );
		}
	}

	updateQueryParams( newCategories, clearFilters = false ) {
		const params = new URLSearchParams( this.props.location.search );

		if ( newCategories.length === 0 ) {
			// Remove the subcategories parameter if no categories are selected
			params.delete( 'subcategories' );
		} else {
			// Otherwise, set the subcategories parameter with the updated categories
			params.set( 'subcategories', newCategories.join( ',' ) );
		}

		const newUrl = `${ this.props.location.pathname }?${ params.toString() }`;
		this.props.history.replace( newUrl );

		// Optionally, fetch posts again based on the new subcategories
		this.props.fetchPosts( this.activeCategory, this.props.pagination.perPage, this.props.pagination.pageNum, this.props.searchTerm, this.props.dateRange.startDate, this.props.dateRange.endDate, newCategories );
		if (clearFilters) {
			this.props.fetchPosts(this.activeCategory, this.props.pagination.perPage, this.props.pagination.pageNum, '', '', '', []);
		}
		const subCategorySlugs = this.getSubCategorySlugs( newCategories );

		const topLevelCategoryDetails = ISDA_Main.categories.find( ( category ) => category.slug === this.activeCategory );
		if (topLevelCategoryDetails.children.length > 4 && subCategorySlugs.length >= topLevelCategoryDetails.children.length - 1) {
			this.props.fetchMultipleFeatured( [this.activeCategory] );
		} else {
			this.props.fetchMultipleFeatured( subCategorySlugs.length > 0
											? subCategorySlugs
											: [this.activeCategory] );
		}
	}


	getView( view ) {
		if ( view === 'magazine' ) {
			if ( this.props.match.params.subCategorySlug === 'fpml' ) {
				return <PostView/>;
			}

			return <MagazineView/>;
		}

		return <PostView/>;
	}

	getFeaturedHero() {
		return <BlueHero featured={ this.props.featured } key="blue-hero"/>;
	}

	createCategoryHeading() {
		const subCategories = this.getSubCategroies();
		if ( subCategories.length > 0 ) {
			const categoryNames = ISDA_Main.categories
			                               .filter( ( category ) => {
				                               return subCategories.includes( String( category.cat_ID ) );
			                               } )
			                               .map( ( category ) => category.name );

			let formattedName = '';
			if ( categoryNames.length > 1 ) {
				let lastCategoryName = categoryNames.pop();
				let allCategoryNames = categoryNames.join( ', ' );
				formattedName = allCategoryNames + ' and ' + lastCategoryName;
			} else {
				formattedName = categoryNames[ 0 ];
			}
			return (<div className="category-title-heading">
						<h2 className="blue-hero-title"> { this.activeCategoryNiceName } :</h2>
					<div
						className={ 'subcategory-heading-names' }>
						<h4>{ formattedName }</h4>
					</div>
				</div>
			);

		} else {
			return (
				<h2 className="blue-hero-title"> { this.activeCategory === 'all' || this.activeCategory === 'All' ? 'All Articles' : this.activeCategoryNiceName } </h2>
			);

		}
	}

	render() {

		if ( this.props.match.params.categorySlug === 'opinions' ) {
			return (<div>
					{ this.getView( this.props.view ) }
					<Pagination/>
				</div>
			);
		}

		return (<div>
				<div id="react-scroll-point">
					<div className={ 'decoy-side-bar' }/>
					{ (!this.state.isMobile || this.state.showFilters
					  ) && <div className={ 'col-lg-3 filter-side-bar' }
					            ref={ this.sidebarRef }>
						  <FilterSideBar
							  topLevelCategory={ this.props.match.params.categorySlug }
							  currentCategorySlug={ this.activeCategory }
							  subCategories={ this.getSubCategroies() }
							  onCheckboxChange={ this.updateQueryParams.bind( this ) } // Bind this to preserve context
							  mobile={ false }
							  filterVisible={ this.state.showFilters }
							  toggleFilters={ this.toggleFilters.bind( this ) }
						  />
					  </div> }
					<div className={ 'col-lg-9 main-content' }>
						{ this.createCategoryHeading() }
						{ this.props.loading ? <Loading height={300} width={'100%'} amount={1} marginBottom={20} marginTop={20} /> : this.getFeaturedHero() }
						<button onClick={ this.toggleFilters.bind( this ) }
						        className="filter-button">
							Filter Options
						</button>
						<div className={ 'category-display-data' }>
							<strong>Found { this.props.pagination.totalResults } articles</strong>
						</div>
						{ this.props.loading ? <Loading height={200} width={'100%'} amount={5} marginBottom={10} marginTop={10} /> : this.getView( this.props.view ) }
						<Pagination/>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps( {
	view, pagination, searchTerm, dateRange, categories, featured, loading
}, ownProps ) {
	return {
		view,
		pagination,
		searchTerm,
		dateRange,
		categories,
		featured,
		location: ownProps.location,
		loading
	};
}

export default connect( mapStateToProps, {
	fetchPosts, fetchCategories, fetchFeatured, fetchMultipleFeatured, setPage, getPageNum
} )( ArchiveSearch );
